import { GAME_ID } from 'a/eReader/data/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

import { READING_ACTION_TYPES } from '../actions/action_types';

const initialState = {};

const gameDetailsReducer = (state = initialState, { gameId, type, stateData, payload }) => {
  if (gameId && !gameId.includes(GAME_ID)) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
      return {
        ...state,
        ...(stateData[gameId].GameData || {}).gameDetails,
      };

    case READING_ACTION_TYPES.UPDATE_GAME_DETAILS: {
      const { bookId, chapter, isPractice } = payload;
      return {
        ...state,
        bookId,
        chapter,
        isPractice,
      };
    }

    case READING_ACTION_TYPES.UPDATE_LOCAL_BOOK_STATE: {
      const { gameDetails } = payload;
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          ...gameDetails,
        },
      };
    }

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    case READING_ACTION_TYPES.SET_IS_DEEP_LINK_MASTERED:
      return {
        ...state,
        isDeepLinkMastered: true,
      };

    default:
      return state;
  }
};

export default gameDetailsReducer;
